import { Typography, Button, Video, } from '../../components';
import { Container, Introduction, Informatie, Downloadable, Aanmelden, IntroductionText, FlexButton } from './styled';
import { Ervaringen } from '../../subpages';

export default function Lactatiekunde(props) {
       
    const AanmeldenContent = (props) => {
        return (
            <Aanmelden color={props.color}>
                <Typography type='h2' style={{ fontSize: '2em' }}>Contact</Typography>
                <Button text='Plan een gesprek' to='/gesprek' style={{ margin: 'auto' }} />
            </Aanmelden>
        )
    }

    return (
        <Container>
            <Introduction>
                <IntroductionText>
                    <div>
                        <Typography type='caps' style={{ color: '#145f68', fontSize: '1em', padding: '0' }}>Lactatiekunde</Typography>
                        <Typography type='h1' style={{ color: '#032d34' }}>De nieuwe standaard<br/>in borstvoedingszorg</Typography>
                    </div>
                    <Typography type='h2' style={{ color: '#145f68', fontSize: '1.3em' }}>beter voorbereid,<br/> minder problemen</Typography><br/>
                    <Button text='Plan een gesprek' to='/gesprek' style={{ margin: 'auto' }} />
                </IntroductionText>
                <div style={{ zIndex: '5'}}>
                    <Video videoId='158VSOld1ig' width={'45vw'} />
                </div>
            </Introduction>
            <Informatie>
                <Downloadable>
                    <Typography type='h2'>Informatie</Typography>
                    <FlexButton>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2em', alignItems: 'center'}}>
                    <Button
                        href='https://kenniscentrumvoorzorgprofessionals.centeringfeeding.nl/checkout/gratis-gids-voor-professionals-de-nieuwe-standaard-in-borstvoedingszorg/s/cfsite'
                        text='Gids voor professionals'
                        buttonstyle="secondary" style={{ margin: 'auto' }}
                        target='_blank'
                    />
                    <Button
                        href='https://kenniscentrumvoorzorgprofessionals.centeringfeeding.nl/checkout/gratis-routekaart-centering-feeding-voor-lactatiekundigen/s/cfsite'
                        text='Routekaart Centering Feeding'
                        buttonstyle='secondary' style={{ margin: 'auto' }}
                        target='_blank'
                    />
                    </div>
                    </FlexButton>
                </Downloadable>
            </Informatie>
            <Ervaringen />
            <AanmeldenContent color='#F1E3D4' />
        </Container>
    )
}